module.exports = __webpack_public_path__ + "img/304_26@3x.c329bdc3.png";